import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_TOURNAMENT } from '@/modules/tournament/router';
import { tournamentService } from '@/services/tournament';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useTournamentLeaderboardEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: StringUtils.toNumber(route.params.id),
        name: '',
        timeUnit: 0,
        timeDuration: null,
        publishTime: new Date(),
        unpublishTime: null
    });

    const validations = {
        name: { required },
        unpublishTime: {}
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => tournamentService.leaderboard.get(model.id),
        onSuccess: ({ data }) => {
            data.publishTime = new Date(data.publishTime);
            data.unpublishTime = data.unpublishTime ? new Date(data.unpublishTime) : null;
            Object.assign(model, data);
        },
        onError: () => router.push({ name: ROUTE_NAME_TOURNAMENT.LEADERBOARD.INDEX })
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () => {
                const unpublishTime = model.unpublishTime?.getTime() ?? null;
                return tournamentService.leaderboard.update(model.id, model.name, unpublishTime);
            },
            onSuccess: () => router.push({ name: ROUTE_NAME_TOURNAMENT.LEADERBOARD.INDEX })
        }),
        remove: crudAction.confirmAndRemove({
            request: () => tournamentService.leaderboard.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_TOURNAMENT.LEADERBOARD.INDEX })
        })
    };

    return { model, v$, fetch, actions };
}
